import BaseComponent from '@/components/base'

const selectors = {
  form: 'form',
  formContents: '[data-form-contents]',
  formMessage: '[data-form-message]' // needs data-success, data-fail
};

const classes = {
  showContents: 'show-contents',
  showMessage: 'show-message'
};

export default class NewsletterForm extends BaseComponent {
  static TYPE = 'newsletter-form'

  timeoutId: ReturnType<typeof setTimeout> | null
  focusTimeoutId: ReturnType<typeof setTimeout> | null
  form: HTMLFormElement
  formInput!: HTMLInputElement
  formContents!: HTMLElement
  formMessage!: HTMLElement

  /**
   * NewsletterForm constructor
   */  
  constructor(el: HTMLElement) {
    super(el)

    this.timeoutId = null
    this.focusTimeoutId = null

    this.form = this.el.tagName === 'FORM' ? this.el as HTMLFormElement : this.qs(selectors.form) as HTMLFormElement

    if (!this.form) {
      console.warn(`[${this.type}] - Form element required to initialize`)
      return
    }

    this.formInput = this.form.querySelector('input[type="email"]') as HTMLInputElement
    this.formContents = this.form.querySelector(selectors.formContents) as HTMLElement
    this.formMessage = this.form.querySelector(selectors.formMessage) as HTMLElement
  }

  destroy() {
    window.clearTimeout(this.timeoutId ?? undefined)
    window.clearTimeout(this.focusTimeoutId ?? undefined)

    super.destroy()
  }

  /**
   * Temporarily shows the form message
   *
   * @param message - The message to show
   * @param reset - If true, will call this.reset when finished
   */  
  showMessageWithTimeout(message: string, reset: boolean = false) {
    this.formMessage.innerHTML = message
    this.formContents.classList.add(classes.showMessage)

    window.clearTimeout(this.timeoutId ?? undefined);

    this.timeoutId = setTimeout(() => {
      if (reset) {
        this.reset();
      }

      this.formContents.classList.remove(classes.showMessage)
    }, 3000);
  }

  showFormContents() {
    this.form.classList.add(classes.showContents)

    this.focusTimeoutId = setTimeout(() => {
      this.focusInput();
    }, 100)
  }

  hideFormContents() {
    this.form.classList.remove(classes.showContents)
  }

  // Allow external components to focus the input
  focusInput() {
    this.formInput.focus()
  }

  /**
   * Resets everything to it's initial state.  Only call when form content isn't visible
   */
  reset() {
    this.formInput.value = ''
    this.formInput.dispatchEvent(new Event('change'))
  }

  onSubscribeSuccess() {
    this.showMessageWithTimeout(this.formMessage.dataset.success ?? '', true);
  }

  onSubmitStart() {
    this.showMessageWithTimeout('Submitting...', false);
  }  

  onSubmitFail(errors: Error[] | string) {
    const msg = Array.isArray(errors) ? errors.join('  ') : errors;
    this.showMessageWithTimeout(msg, false);
  }

  onSubscribeFail() {
    this.showMessageWithTimeout(this.formMessage.dataset.fail ?? '', false);
  }
}